import React from "react";
import { ThemeProvider } from "styled-components";

import Peracto from "@peracto/peracto";
import Config from "@peracto/peracto-config";
import PeractoUser from "@peracto/peracto-user";
import PeractoCatalogue from "@peracto/peracto-catalogue";
import PeractoCommon from "@peracto/peracto-common";
import PeractoContent from "@peracto/peracto-content";
import PeractoLocations from "@peracto/peracto-locations";
import PeractoPromotions from "@peracto/peracto-promotions";
import TestHarnesses from "packages/test-harnesses";
import { OrdersView } from "packages/peracto-catalogue/Orders";
import {
    ProductImport,
    ProductImportStatus,
} from "packages/peracto-catalogue/Products";

import { EditorTheme, AdminTheme, GlobalStyles } from "./theme";

import blocks from "./blocks";
import { menu } from "./menu";

import compact from "lodash/compact";
import startCase from "lodash/startCase";

import { buttonVariants } from "./theme/buttonVariants";
import { colors, fonts } from "./theme/tailwind";

import {
    Button,
    Input,
    Textarea,
    Select,
    Radio,
    Checkbox,
    CheckboxGroup,
    File,
} from "./Inputs";

const config = new Config({
    api: process.env.REACT_APP_API,
    algolia: {
        applicationId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
        searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
        indexName: process.env.REACT_APP_ALGOLIA_INDEX_NAME,
    },
    modules: [
        PeractoUser(),
        PeractoCommon(),
        PeractoCatalogue({
            OrdersView,
            ProductImport,
            ProductImportStatus,
        }),
        PeractoLocations(),
        PeractoPromotions(),
        PeractoContent(),
        TestHarnesses(),
    ],
    editorConfig: {
        isTailwind: true,
        theme: {
            ...EditorTheme,
            breakpoints: {
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "1360px",
            },
        },
        screens: {
            sm: "100%",
            md: "100%",
            lg: "100%",
            xl: "1360px",
        },
        colorOptions: compact(
            Object.entries(colors).map(([label, value]) => {
                return {
                    label: startCase(label.replaceAll("brand-", "")),
                    value,
                };
            }),
        ),
        fonts,
        locales: ["en_GB"],
        blocks,
        buttonVariants,
        inputTypes: {
            Button,
            Input,
            Textarea,
            Select,
            Radio,
            Checkbox,
            CheckboxGroup,
            File,
        },
        stylesheets: ["https://use.typekit.net/eoz2zhk.css"],
        globalStyles: GlobalStyles,
    },
    features: {
        shippingServices: {
            deliveryDays: true,
            conditions: true,
        },
        products: {
            exportProductData: true,
            productVariants: true,
            filterRelatedProductsBySku: true,
        },
        user: {
            userGroups: true,
        },
        orders: {
            exportOrderData: true,
        },
    },
    menu,
});

const App = () => (
    <ThemeProvider theme={AdminTheme}>
        <Peracto config={config} />
    </ThemeProvider>
);

export default App;
